module.exports = __webpack_public_path__ + "pc/img/work_list5.ef3ad707.jpg";